/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { JsonApiLinksDto } from "../JsonApiLinksDto";
import type { PaginationMeta } from "../PaginationMeta";

export type HierarchiesControllerGetDescendantsPathParams = {
    /**
     * @description Scope ID
     * @type string
    */
    scopeId: string;
};

export const hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum = {
    "ORGANIZATION": "ORGANIZATION",
    "PROMPT": "PROMPT",
    "FILE": "FILE",
    "PROJECT": "PROJECT",
    "SYSTEM": "SYSTEM",
    "WORKSPACE": "WORKSPACE",
    "TEAM": "TEAM",
    "FOLDER": "FOLDER",
    "USER": "USER",
    "CHAT_MESSAGE": "CHAT_MESSAGE",
    "CLIENT": "CLIENT",
    "THREAD": "THREAD",
    "PROJECT_TYPE": "PROJECT_TYPE",
    "OWNER": "OWNER",
    "ARCHITECT": "ARCHITECT",
    "DEPARTMENT": "DEPARTMENT",
    "REGION": "REGION",
    "CHECKLIST_TEMPLATE": "CHECKLIST_TEMPLATE",
    "TRIAL": "TRIAL",
    "CHANGE_ORDER": "CHANGE_ORDER",
    "SOURCE_RECORD": "SOURCE_RECORD",
    "all": "all"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsScopeTypeEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum];

export const hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum = {
    "PENDING": "PENDING",
    "UPLOADING": "UPLOADING",
    "UPLOADED": "UPLOADED",
    "PROCESSING": "PROCESSING",
    "READY": "READY",
    "FAILED": "FAILED",
    "ARCHIVED": "ARCHIVED",
    "DELETED": "DELETED",
    "VERSIONED": "VERSIONED"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum];

export const hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum = {
    "PRIME_CONTRACT": "PRIME_CONTRACT",
    "SUBCONTRACT": "SUBCONTRACT",
    "SPECIFICATIONS": "SPECIFICATIONS",
    "DRAWING": "DRAWING",
    "DRAWING_SET": "DRAWING_SET",
    "OTHER": "OTHER"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum];

export type HierarchiesControllerGetDescendantsQueryParams = {
    /**
     * @description Type(s) of scope for filtering descendant scopes. Can be a single type or comma-separated list (e.g., FILE,FOLDER)
     * @type string
    */
    scopeType: HierarchiesControllerGetDescendantsQueryParamsScopeTypeEnumKey;
    /**
     * @description Maximum depth of hierarchy to retrieve
     * @minLength 1
     * @default 5
     * @type number | undefined
    */
    maxDepth?: number;
    /**
     * @description Load children lazily (returns links for children instead of full data)
     * @default false
     * @type boolean | undefined
    */
    lazyLoadChildren?: boolean;
    /**
     * @description Number of items per page
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    pageSize?: number;
    /**
     * @description Page number for offset-based pagination
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Sort field and order (prefix with - for descending)
     * @type string | undefined
    */
    sort?: string;
    /**
     * @description Search term to filter children by entity name (and description/referenceNumber for projects). Case-insensitive partial match.
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Include soft-deleted entities (teams, organizations, clients) in the response. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description Return only archived projects, folders and files. This is what the Archive listing reads; it overrides includeArchived.
     * @default false
     * @type boolean | undefined
    */
    archiveView?: boolean;
    /**
     * @description Include archived projects, folders and files in the response. Default is false, so an archived item leaves the active listing the way a deleted one does.
     * @default false
     * @type boolean | undefined
    */
    includeArchived?: boolean;
    /**
     * @description Include the scope itself (the scopeId used in the request) in the ancestor results. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeSelf?: boolean;
    /**
     * @description File statuses to exclude from results. Can be a single status or comma-separated list (e.g., \"PENDING,UPLOADING\")
     * @type array | undefined
    */
    excludeFileStatuses?: HierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnumKey[];
    /**
     * @description Document types to filter FILE children by. Can be a single type or comma-separated list (e.g., \"PRIME_CONTRACT,SUBCONTRACT\"). Unlike excludeFileStatuses, this narrows results to files only — non-FILE children (folders) are excluded while it is active.
     * @type array | undefined
    */
    fileDocumentTypes?: HierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnumKey[];
    /**
     * @description Load entity data (folder.name, file.fileName, etc.) so results carry real display names. Set false when only counts/structure are needed, to skip the entity joins. Default is true; ignored (forced on) when a search term is present, since name filtering requires it.
     * @default true
     * @type boolean | undefined
    */
    includeEntities?: boolean;
};

export const dataTypeEnum2949 = {
    "hierarchies": "hierarchies"
} as const;

export type DataTypeEnum2949Key = (typeof dataTypeEnum2949)[keyof typeof dataTypeEnum2949];

export const attributesTypeEnum10 = {
    "ORGANIZATION": "ORGANIZATION",
    "TEAM": "TEAM",
    "PROJECT": "PROJECT",
    "FILE": "FILE",
    "FOLDER": "FOLDER",
    "CLIENT": "CLIENT"
} as const;

export type AttributesTypeEnum10Key = (typeof attributesTypeEnum10)[keyof typeof attributesTypeEnum10];

export const dataTypeEnum2950 = {
    "organizations": "organizations"
} as const;

export type DataTypeEnum2950Key = (typeof dataTypeEnum2950)[keyof typeof dataTypeEnum2950];

export const dataTypeEnum2951 = {
    "teams": "teams"
} as const;

export type DataTypeEnum2951Key = (typeof dataTypeEnum2951)[keyof typeof dataTypeEnum2951];

export const dataTypeEnum2952 = {
    "projects": "projects"
} as const;

export type DataTypeEnum2952Key = (typeof dataTypeEnum2952)[keyof typeof dataTypeEnum2952];

export const dataTypeEnum2953 = {
    "files": "files"
} as const;

export type DataTypeEnum2953Key = (typeof dataTypeEnum2953)[keyof typeof dataTypeEnum2953];

export const dataTypeEnum2954 = {
    "folders": "folders"
} as const;

export type DataTypeEnum2954Key = (typeof dataTypeEnum2954)[keyof typeof dataTypeEnum2954];

export const dataTypeEnum2955 = {
    "clients": "clients"
} as const;

export type DataTypeEnum2955Key = (typeof dataTypeEnum2955)[keyof typeof dataTypeEnum2955];

export const includedTypeEnum2088 = {
    "hierarchies": "hierarchies"
} as const;

export type IncludedTypeEnum2088Key = (typeof includedTypeEnum2088)[keyof typeof includedTypeEnum2088];

export const includedTypeEnum2089 = {
    "organizations": "organizations"
} as const;

export type IncludedTypeEnum2089Key = (typeof includedTypeEnum2089)[keyof typeof includedTypeEnum2089];

export const dataTypeEnum2956 = {
    "scopes": "scopes"
} as const;

export type DataTypeEnum2956Key = (typeof dataTypeEnum2956)[keyof typeof dataTypeEnum2956];

export const dataTypeEnum2957 = {
    "trial-summaries": "trial-summaries"
} as const;

export type DataTypeEnum2957Key = (typeof dataTypeEnum2957)[keyof typeof dataTypeEnum2957];

export const dataTypeEnum2958 = {
    "domains": "domains"
} as const;

export type DataTypeEnum2958Key = (typeof dataTypeEnum2958)[keyof typeof dataTypeEnum2958];

export const includedTypeEnum2090 = {
    "teams": "teams"
} as const;

export type IncludedTypeEnum2090Key = (typeof includedTypeEnum2090)[keyof typeof includedTypeEnum2090];

export const dataTypeEnum2959 = {
    "users": "users"
} as const;

export type DataTypeEnum2959Key = (typeof dataTypeEnum2959)[keyof typeof dataTypeEnum2959];

export const dataTypeEnum2960 = {
    "principals": "principals"
} as const;

export type DataTypeEnum2960Key = (typeof dataTypeEnum2960)[keyof typeof dataTypeEnum2960];

export const dataTypeEnum2961 = {
    "offices": "offices"
} as const;

export type DataTypeEnum2961Key = (typeof dataTypeEnum2961)[keyof typeof dataTypeEnum2961];

export const includedTypeEnum2091 = {
    "projects": "projects"
} as const;

export type IncludedTypeEnum2091Key = (typeof includedTypeEnum2091)[keyof typeof includedTypeEnum2091];

export const dataTypeEnum2962 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type DataTypeEnum2962Key = (typeof dataTypeEnum2962)[keyof typeof dataTypeEnum2962];

export const dataTypeEnum2963 = {
    "project-types": "project-types"
} as const;

export type DataTypeEnum2963Key = (typeof dataTypeEnum2963)[keyof typeof dataTypeEnum2963];

export const dataTypeEnum2964 = {
    "owners": "owners"
} as const;

export type DataTypeEnum2964Key = (typeof dataTypeEnum2964)[keyof typeof dataTypeEnum2964];

export const dataTypeEnum2965 = {
    "architects": "architects"
} as const;

export type DataTypeEnum2965Key = (typeof dataTypeEnum2965)[keyof typeof dataTypeEnum2965];

export const dataTypeEnum2966 = {
    "departments": "departments"
} as const;

export type DataTypeEnum2966Key = (typeof dataTypeEnum2966)[keyof typeof dataTypeEnum2966];

export const dataTypeEnum2967 = {
    "regions": "regions"
} as const;

export type DataTypeEnum2967Key = (typeof dataTypeEnum2967)[keyof typeof dataTypeEnum2967];

export const dataTypeEnum2968 = {
    "external-project-links": "external-project-links"
} as const;

export type DataTypeEnum2968Key = (typeof dataTypeEnum2968)[keyof typeof dataTypeEnum2968];

export const includedTypeEnum2092 = {
    "files": "files"
} as const;

export type IncludedTypeEnum2092Key = (typeof includedTypeEnum2092)[keyof typeof includedTypeEnum2092];

export const includedTypeEnum2093 = {
    "folders": "folders"
} as const;

export type IncludedTypeEnum2093Key = (typeof includedTypeEnum2093)[keyof typeof includedTypeEnum2093];

export const includedTypeEnum2094 = {
    "clients": "clients"
} as const;

export type IncludedTypeEnum2094Key = (typeof includedTypeEnum2094)[keyof typeof includedTypeEnum2094];

export const includedTypeEnum2095 = {
    "scopes": "scopes"
} as const;

export type IncludedTypeEnum2095Key = (typeof includedTypeEnum2095)[keyof typeof includedTypeEnum2095];

export const includedTypeEnum2096 = {
    "trial-summaries": "trial-summaries"
} as const;

export type IncludedTypeEnum2096Key = (typeof includedTypeEnum2096)[keyof typeof includedTypeEnum2096];

export const includedTypeEnum2097 = {
    "domains": "domains"
} as const;

export type IncludedTypeEnum2097Key = (typeof includedTypeEnum2097)[keyof typeof includedTypeEnum2097];

export const includedTypeEnum2098 = {
    "users": "users"
} as const;

export type IncludedTypeEnum2098Key = (typeof includedTypeEnum2098)[keyof typeof includedTypeEnum2098];

export const dataTypeEnum2969 = {
    "user-preferences": "user-preferences"
} as const;

export type DataTypeEnum2969Key = (typeof dataTypeEnum2969)[keyof typeof dataTypeEnum2969];

export const includedTypeEnum2099 = {
    "offices": "offices"
} as const;

export type IncludedTypeEnum2099Key = (typeof includedTypeEnum2099)[keyof typeof includedTypeEnum2099];

export const includedTypeEnum2100 = {
    "principals": "principals"
} as const;

export type IncludedTypeEnum2100Key = (typeof includedTypeEnum2100)[keyof typeof includedTypeEnum2100];

export const dataTypeEnum2970 = {
    "members": "members"
} as const;

export type DataTypeEnum2970Key = (typeof dataTypeEnum2970)[keyof typeof dataTypeEnum2970];

export const dataTypeEnum2971 = {
    "principalRoles": "principalRoles"
} as const;

export type DataTypeEnum2971Key = (typeof dataTypeEnum2971)[keyof typeof dataTypeEnum2971];

export const includedTypeEnum2101 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type IncludedTypeEnum2101Key = (typeof includedTypeEnum2101)[keyof typeof includedTypeEnum2101];

export const includedTypeEnum2102 = {
    "project-types": "project-types"
} as const;

export type IncludedTypeEnum2102Key = (typeof includedTypeEnum2102)[keyof typeof includedTypeEnum2102];

export const includedTypeEnum2103 = {
    "owners": "owners"
} as const;

export type IncludedTypeEnum2103Key = (typeof includedTypeEnum2103)[keyof typeof includedTypeEnum2103];

export const includedTypeEnum2104 = {
    "architects": "architects"
} as const;

export type IncludedTypeEnum2104Key = (typeof includedTypeEnum2104)[keyof typeof includedTypeEnum2104];

export const includedTypeEnum2105 = {
    "departments": "departments"
} as const;

export type IncludedTypeEnum2105Key = (typeof includedTypeEnum2105)[keyof typeof includedTypeEnum2105];

export const includedTypeEnum2106 = {
    "regions": "regions"
} as const;

export type IncludedTypeEnum2106Key = (typeof includedTypeEnum2106)[keyof typeof includedTypeEnum2106];

export const includedTypeEnum2107 = {
    "external-project-links": "external-project-links"
} as const;

export type IncludedTypeEnum2107Key = (typeof includedTypeEnum2107)[keyof typeof includedTypeEnum2107];

export const includedTypeEnum2108 = {
    "user-preferences": "user-preferences"
} as const;

export type IncludedTypeEnum2108Key = (typeof includedTypeEnum2108)[keyof typeof includedTypeEnum2108];

export const includedTypeEnum2109 = {
    "members": "members"
} as const;

export type IncludedTypeEnum2109Key = (typeof includedTypeEnum2109)[keyof typeof includedTypeEnum2109];

export const dataTypeEnum2972 = {
    "roles": "roles"
} as const;

export type DataTypeEnum2972Key = (typeof dataTypeEnum2972)[keyof typeof dataTypeEnum2972];

export const dataTypeEnum2973 = {
    "scope-access": "scope-access"
} as const;

export type DataTypeEnum2973Key = (typeof dataTypeEnum2973)[keyof typeof dataTypeEnum2973];

export const includedTypeEnum2110 = {
    "principalRoles": "principalRoles"
} as const;

export type IncludedTypeEnum2110Key = (typeof includedTypeEnum2110)[keyof typeof includedTypeEnum2110];

export type HierarchiesControllerGetDescendants200 = {
    /**
     * @type array
    */
    data: {
        /**
         * @type string
        */
        id: string;
        type: DataTypeEnum2949Key;
        /**
         * @description Resource attributes (excluding relationships)
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            type?: AttributesTypeEnum10Key;
            parentId?: (string | null);
            /**
             * @type number | undefined
            */
            depth?: number;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type boolean | undefined
            */
            private?: boolean;
            /**
             * @type string | undefined
            */
            name?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            archivedAt?: (string | null);
            organization?: (object | null);
            team?: (object | null);
            project?: (object | null);
            file?: (object | null);
            folder?: (object | null);
            client?: (object | null);
            /**
             * @type boolean | undefined
            */
            isArchived?: boolean;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2951Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2954Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2955Key;
                });
            };
        };
    }[];
    /**
     * @description Additional resources referenced by the data
     * @type array | undefined
    */
    included?: ({
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2088Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            organization?: string;
            /**
             * @type string | undefined
            */
            team?: string;
            /**
             * @type string | undefined
            */
            project?: string;
            /**
             * @type string | undefined
            */
            file?: string;
            /**
             * @type string | undefined
            */
            folder?: string;
            /**
             * @type string | undefined
            */
            client?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2951Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2954Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2955Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2089Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            trimbleIamAccountId?: string;
            /**
             * @type string | undefined
            */
            trimbleCdhAccountId?: string;
            /**
             * @type string | undefined
            */
            ssoEnabled?: string;
            /**
             * @type string | undefined
            */
            dataProtectionEnabled?: string;
            /**
             * @type string | undefined
            */
            organizationSkillsEnabled?: string;
            /**
             * @type string | undefined
            */
            emsValidationEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedProjectChatEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedContentChatEnabled?: string;
            /**
             * @type string | undefined
            */
            apiAccessEnabled?: string;
            /**
             * @type string | undefined
            */
            isInternal?: string;
            /**
             * @type string | undefined
            */
            enabledIntegrations?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            entitlement?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            trial?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2957Key;
                });
            };
            /**
             * @type object | undefined
            */
            clients?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2955Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            domains?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2958Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            teams?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2951Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            folders?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2954Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            files?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            descendants?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2949Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2090Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            members?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            sourceOffice?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2961Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2091Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            visibility?: string;
            /**
             * @type string | undefined
            */
            stage?: string;
            /**
             * @type string | undefined
            */
            location?: string;
            /**
             * @type string | undefined
            */
            startDate?: string;
            /**
             * @type string | undefined
            */
            endDate?: string;
            /**
             * @type string | undefined
            */
            description?: string;
            /**
             * @type string | undefined
            */
            value?: string;
            /**
             * @type string | undefined
            */
            referenceNumber?: string;
            /**
             * @type string | undefined
            */
            deliverable?: string;
            /**
             * @type string | undefined
            */
            deliveryMethod?: string;
            /**
             * @type string | undefined
            */
            division?: string;
            /**
             * @type string | undefined
            */
            details?: string;
            /**
             * @type string | undefined
            */
            imageUrl?: string;
            /**
             * @type string | undefined
            */
            workflowCount?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            sampleProjectTemplate?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2962Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2955Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectType?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2963Key;
                });
            };
            /**
             * @type object | undefined
            */
            owner?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2964Key;
                });
            };
            /**
             * @type object | undefined
            */
            architect?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2965Key;
                });
            };
            /**
             * @type object | undefined
            */
            department?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2966Key;
                });
            };
            /**
             * @type object | undefined
            */
            region?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2967Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectLead?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            externalLinks?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2968Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2092Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            fileUuid?: string;
            /**
             * @type string | undefined
            */
            originalName?: string;
            /**
             * @type string | undefined
            */
            fileName?: string;
            /**
             * @type string | undefined
            */
            mimeType?: string;
            /**
             * @type string | undefined
            */
            fileSize?: string;
            /**
             * @type string | undefined
            */
            checksum?: string;
            /**
             * @type string | undefined
            */
            bucket?: string;
            /**
             * @type string | undefined
            */
            fileKey?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            fileDocumentType?: string;
            /**
             * @type string | undefined
            */
            processingStartedAt?: string;
            /**
             * @type string | undefined
            */
            processingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            pageCount?: string;
            /**
             * @type string | undefined
            */
            duration?: string;
            /**
             * @type string | undefined
            */
            dimensions?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            version?: string;
            /**
             * @type string | undefined
            */
            versionName?: string;
            /**
             * @type string | undefined
            */
            versionDescription?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            rootFile?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                });
            };
            /**
             * @type object | undefined
            */
            versions?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2093Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2094Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2095Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2951Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2954Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2096Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            projectCount?: string;
            /**
             * @type string | undefined
            */
            projectCap?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2097Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2098Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            phoneNumber?: string;
            /**
             * @type string | undefined
            */
            companyRole?: string;
            /**
             * @type string | undefined
            */
            acceptedTerms?: string;
            /**
             * @type string | undefined
            */
            termsAcceptedAt?: string;
            /**
             * @type string | undefined
            */
            lastLoginAt?: string;
            /**
             * @type string | undefined
            */
            timezone?: string;
            /**
             * @type string | undefined
            */
            avatarUrl?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            changeOrderAccess?: string;
            /**
             * @type string | undefined
            */
            trimbleSub?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            preferences?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2969Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2099Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            uuid?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            isActive?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2100Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            cognitoSubs?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            memberships?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2970Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdFiles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2953Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            roles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2971Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2101Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2102Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2103Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2104Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2105Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2106Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2950Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2107Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            provider?: string;
            /**
             * @type string | undefined
            */
            externalCompanyId?: string;
            /**
             * @type string | undefined
            */
            externalProjectId?: string;
            /**
             * @type string | undefined
            */
            scopeId?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2952Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2108Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            currentTeamId?: string;
            /**
             * @type string | undefined
            */
            theme?: string;
            /**
             * @type string | undefined
            */
            language?: string;
            /**
             * @type string | undefined
            */
            timezoneOverride?: string;
            /**
             * @type string | undefined
            */
            dashboardLayout?: string;
            /**
             * @type string | undefined
            */
            onboardingStatus?: string;
            /**
             * @type string | undefined
            */
            onboardingGoals?: string;
            /**
             * @type string | undefined
            */
            onboardingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            skillsEducationDismissedAt?: string;
            /**
             * @type string | undefined
            */
            onboardingTaskCompletions?: string;
            /**
             * @type string | undefined
            */
            onboardingTasksLoginViews?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            currentTeam?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2951Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2109Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            membershipType?: string;
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string | undefined
            */
            roleName?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            message?: string;
            /**
             * @type string | undefined
            */
            inviteStatus?: string;
            /**
             * @type string | undefined
            */
            isInherited?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2972Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2959Key;
                });
            };
            /**
             * @type object | undefined
            */
            invitedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            inheritedFrom?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            scopeAccess?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2973Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2110Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2960Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2956Key;
                });
            };
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2972Key;
                });
            };
        };
    })[];
    /**
     * @type object | undefined
    */
    meta?: PaginationMeta;
    /**
     * @type object | undefined
    */
    links?: JsonApiLinksDto;
};

/**
 * @description Unauthorized
*/
export type HierarchiesControllerGetDescendants401 = any;

/**
 * @description Forbidden - insufficient permissions
*/
export type HierarchiesControllerGetDescendants403 = any;

export type HierarchiesControllerGetDescendantsQueryResponse = HierarchiesControllerGetDescendants200;

export type HierarchiesControllerGetDescendantsQuery = {
    Response: HierarchiesControllerGetDescendants200;
    PathParams: HierarchiesControllerGetDescendantsPathParams;
    QueryParams: HierarchiesControllerGetDescendantsQueryParams;
    Errors: HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403;
};